import { storyActions, fleekActions } from '../actionTypes';

const initialState = {
  data: {},
  loading: false,
  error: null,
  recentPostsData: {},
  miniPLP: {}
};

const brandsPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case fleekActions.FETCH_BRANDS_PAGE_DATA_REQUEST:
      return {
        ...state,
        loading: true
      };

    case fleekActions.FETCH_BRANDS_PAGE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload
      };

    case fleekActions.FETCH_BRANDS_PAGE_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case fleekActions.FETCH_BRANDS_PAGE_RECENT_POSTS_DATA_REQUEST:
      return {
        ...state,
        loading: true
      };

    case fleekActions.FETCH_BRANDS_PAGE_RECENT_POSTS_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        recentPostsData: action.payload
      };

    case fleekActions.FETCH_MINI_PLP_DATA_SUCCESS:
      return {
        ...state,
        // loading: false,
        miniPLP: action.payload
      };

    case fleekActions.UPDATE_BRANDS_PAGE_RECENT_POSTS_DATA_SUCCESS:
      if (
        action.payload?.layout?.components?.length > 0 &&
        action.payload?.layout?.components[0]?.subcomponents.length > 0
      ) {
        const newComponents = state.recentPostsData.layout.components.map(el => {
          if (el.template === 'RECENT_POSTS') {
            return {
              ...el,
              subcomponents: [
                ...el.subcomponents,
                ...action.payload?.layout?.components[0]?.subcomponents
              ],
              pagination: {
                ...el.pagination,
                pageNumber: action.payload?.layout?.components[0]?.pagination?.pageNumber
              }
            };
          }
          return el;
        });
        return {
          ...state,
          loading: false,
          recentPostsData: {
            ...state.recentPostsData,
            layout: {
              ...state.recentPostsData.layout,
              components: newComponents
            }
          }
        };
      }

    case fleekActions.FETCH_BRANDS_PAGE_RECENT_POSTS_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case storyActions.SUB_STORY_SEEN:
      return {
        ...state,
        data: {
          ...state.data,
          layout: {
            ...state.data.layout,
            components: [...action.payload.neewBrandPageComponents]
          }
        }
      };
    default:
      return state;
  }
};

export default brandsPageReducer;
